import { useState, type FormEvent } from "react";

import { useChangePasswordMutation } from "@/api/auth";
import { ApiError } from "@/api/client";
import { BrandMark, BrandName, Button, Ribbon } from "@/components/ui";
import { t } from "@/i18n";

/** /sifre — sozlesme §2. Oturum acmis kullanici kendi sifresini degistirir.
 * Layout DISINDA (App.tsx) — Giris.tsx ile ayni kart/zemin duzeni. */
export function Sifre() {
  const changePasswordMutation = useChangePasswordMutation();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSuccess(false);
    try {
      await changePasswordMutation.mutateAsync({ current_password: currentPassword, new_password: newPassword });
      setSuccess(true);
      setCurrentPassword("");
      setNewPassword("");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t("common.error"));
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-pale to-bg px-4 py-8">
      <form
        onSubmit={(e) => void handleSubmit(e)}
        className="w-full max-w-[420px] space-y-4 rounded-2xl border-[1.5px] border-line bg-card p-7 shadow-login sm:p-9"
      >
        <div className="mb-2 flex flex-col items-center text-center">
          <BrandMark size={52} className="mb-3" />
          <BrandName className="text-[22px]" />
        </div>

        <h1 className="font-display text-lg font-bold text-ink">{t("auth.password.title")}</h1>

        <div>
          <label htmlFor="currentPassword" className="label">
            {t("auth.password.current")}
          </label>
          <input
            id="currentPassword"
            type="password"
            required
            autoComplete="current-password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className="input"
          />
        </div>
        <div>
          <label htmlFor="newPassword" className="label">
            {t("auth.password.new")}
          </label>
          <input
            id="newPassword"
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="input"
          />
        </div>

        {error && <Ribbon tone="bad">{error}</Ribbon>}
        {success && <Ribbon tone="ok">{t("auth.password.success")}</Ribbon>}

        <Button type="submit" variant="primary" disabled={changePasswordMutation.isPending} className="w-full !min-h-[46px] text-[15px]">
          {t("auth.password.submit")}
        </Button>
      </form>
    </div>
  );
}
